import { useState } from "react";
import {
  IconButton,
  Drawer,
  Typography,
  Divider,
  Badge,
  Stack,
} from "@mui/material";
import NotificationsIcon from "@mui/icons-material/Notifications";
import CloseIcon from "@mui/icons-material/Close";
import {
  useNotificationsApiV1GetActivityCountQuery,
  useNotificationsApiV1GetNotificationsQuery,
  useWebApiV1UpdateUserActivityLastViewedMutation,
} from "@providers/hop-ord-server/api";
import NotificationItem from "./NotificationItem";
import { NotificationOut } from "@providers/hop-ord-server/api";
import { PAGE_HEADER_HEIGHT } from "@constants";

const NO_NOTIFICATIONS = "No notifications from the last 30 days.";
const ALL_NOTIFICATIONS =
  "That's all your notifications from the last 30 days.";
const Notifications = () => {
  const appBarHeight = document.getElementById("app-bar")?.clientHeight;
  const [notificationPanelOpen, setNotificationPanelOpen] = useState(false);
  const { data } = useNotificationsApiV1GetNotificationsQuery({
    deviceToken: "-1",
  });
  const { data: activityCount } = useNotificationsApiV1GetActivityCountQuery();

  const [updateUserActivityLastViewed] =
    useWebApiV1UpdateUserActivityLastViewedMutation();

  const toggleDrawer = () => {
    setNotificationPanelOpen((prevState) => !prevState);
  };

  const handleClick = () => {
    if (!notificationPanelOpen) {
      updateUserActivityLastViewed();
    }
    toggleDrawer();
  };

  return (
    <>
      <IconButton
        data-testid="notification-icon"
        onClick={handleClick}
        color="inherit"
      >
        <Badge badgeContent={activityCount || 0} max={9}>
          <NotificationsIcon />
        </Badge>
      </IconButton>
      <Drawer
        anchor="right"
        open={notificationPanelOpen}
        onClose={() => setNotificationPanelOpen(false)}
        slotProps={{
          paper: {
            sx: {
              top: appBarHeight,
              height: `calc(100vh - ${appBarHeight}px)`,
              width: 600,
            },
          },
        }}
      >
        <Stack
          direction="row"
          gap={2}
          sx={{
            position: "sticky",
            top: 0,
            borderBottom: "1px solid",
            borderColor: "divider",
            backgroundColor: "white",
            zIndex: 1000,
            minHeight: PAGE_HEADER_HEIGHT,
            maxHeight: PAGE_HEADER_HEIGHT,
            alignItems: "center",
            paddingX: 2,
          }}
        >
          <IconButton onClick={toggleDrawer} color="secondary">
            <CloseIcon />
          </IconButton>
          <Typography variant="h5">Notifications</Typography>
        </Stack>
        <Stack sx={{ overflowY: "scroll", height: 1 }}>
          {data && data?.length > 0 && (
            <>
              <Stack sx={{ padding: 2 }}>
                {data.map((notification: NotificationOut) => (
                  <NotificationItem
                    notification={notification}
                    key={notification.id}
                    toggleDrawer={toggleDrawer}
                  />
                ))}
              </Stack>
              <Divider />
            </>
          )}
          <Typography
            variant="body2"
            pt="16px"
            pb="16px"
            textAlign="center"
            color="grey.700"
          >
            {data && data.length > 0 ? ALL_NOTIFICATIONS : NO_NOTIFICATIONS}
          </Typography>
        </Stack>
      </Drawer>
    </>
  );
};

export default Notifications;
